<template>
  <div id="app">
    <div
      class="el-backtop"
      style="right: 40px; bottom: 100px;z-index=100"
      v-show="isshow"
      @click="backTop"
    >
      <i class="el-icon-caret-top"></i>
    </div>

    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>


<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      isshow: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },

    // 为了计算距离顶部的高度，当高度大于400显示回顶部图标，小于400则隐藏
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 400) {
        that.isshow = true;
      } else {
        that.isshow = false;
      }
    },
  },
  created() {},
  mounted() {
    if (this._isMobile()) {
      this.$router.replace("/home-m");
    } else {
      this.$router.replace("/home");
    }
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
};
</script>
<style lang="less" scoped>
</style>

